<template>
  <ul>
    <menu-options-item close label="Excluir" label-class="text-negative" @click="$emit('excluir')" icon="times" />
  </ul>
</template>

<script>
import MenuOptionsItem from '../../../../layout/context-menu/context-window-options-item'
export default {
  name: 'lances-automaticos-list-menu',
  components: {MenuOptionsItem}
}
</script>
